const features = [
  {
    icon: 'ri-shield-flash-line',
    title: '海量黑料实时更新',
    desc: '每日更新超过2000条51吃瓜黑料视频，覆盖明星网红、综艺内幕、圈内秘闻等全方位爆料内容。24小时不间断追踪，确保你不错过任何一个热门黑料。',
    color: 'primary',
  },
  {
    icon: 'ri-speed-up-line',
    title: '全网最快爆料速度',
    desc: '专业编辑团队7×24小时轮值监控，重大爆料事件发生后最快15分钟内上线51吃瓜视频。吃瓜趁热，黑料视频在线观看永远快人一步。',
    color: 'accent',
  },
  {
    icon: 'ri-check-double-line',
    title: '多源交叉验证机制',
    desc: '坚持"实锤优先"原则，每条黑料爆料视频上线前均经过至少三个独立信源的交叉验证。不传谣不信谣，让吃瓜群众看得放心。',
    color: 'secondary',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            为什么500万吃瓜群众选择51吃瓜黑料
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, i) => {
            const colorMap: Record<string, { bg: string; iconBg: string; iconColor: string; border: string }> = {
              primary: { bg: 'bg-primary-100/70', iconBg: 'bg-primary-500', iconColor: 'text-background-50', border: 'border-primary-200' },
              accent: { bg: 'bg-accent-100/80', iconBg: 'bg-accent-500', iconColor: 'text-background-50', border: 'border-accent-200' },
              secondary: { bg: 'bg-secondary-100/80', iconBg: 'bg-secondary-500', iconColor: 'text-background-50', border: 'border-secondary-200' },
            };
            const c = colorMap[feature.color];

            return (
              <div
                key={i}
                className={`group rounded-2xl ${c.bg} border ${c.border} p-8 md:p-10 text-center hover:scale-[1.02] transition-transform duration-300`}
              >
                <div className={`w-14 h-14 mx-auto rounded-2xl ${c.iconBg} flex items-center justify-center mb-5`}>
                  <i className={`${feature.icon} text-2xl ${c.iconColor}`}></i>
                </div>
                <h3 className="text-lg font-heading text-foreground-950 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}